import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import LoadingGif from '../../../../static/images/loading.gif'
import AppVars from '../../../../AppVars';

let appVars = AppVars.getInstance()

class PasswordFormView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        return (
            /* FIXME: OnSubmit, the info is showing up in the URL */
            <>
                <div className="justify-content-center line-box">
                    <div role="banner">
                        <Row className="">
                            <a href={appVars.getAppHomeURL(this.props.style)}><Image className="corner-logo absolute" alt="Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></a>
                        </Row>
                    </div>
                    <div
                        id="logonAlert"
                        data-testid="accountLockedError"
                        className={`${this.props.isAccountLocked === true ? "error-modal" : "none"}`}
                        role="alert"
                        aria-hidden={`${this.props.isAccountLocked === true ? "false" : "true"}`}
                    >
                        <div className="error-modal-text">
                            The account has been locked due to multiple failed attempts. Please try again after 20 minutes to continue with same password.
                            {/* <a style={{"cursor":"pointer"}} onClick={()=>window.location.replace(appVars.getForgotPasswordURL(this.props.style))}><u>Click here to Reset Password</u></a> */}
                        </div>
                        <span onClick={this.props.hideModalLocked} className="modal-close">&times;</span>
                    </div>
                    <div
                        id="logonAlert"
                        data-testid="temporaryLockedError"
                        className={`${this.props.isLoginValid === false ? "error-modal" : "none"}`}
                        role="alert"
                        aria-hidden={`${this.props.isLoginValid === false ? "false" : "true"}`}
                    >
                        <div className="error-modal-text">
                            Invalid username or password. An excessive number of failed login attempts will temporarily lock your account.
                        </div>
                        <span onClick={this.props.hideModalInvalid} className="modal-close">&times;</span>
                    </div>
                    <div row="main">
                        {/* This row serves a purpose despite not having text. */}
                        <Row className={`${this.props.isLoginValid === false || this.props.isAccountLocked === true ? "none" : "block"}`} style={{ "height": "40px" }}></Row>
                        <Row className="title__TO left">
                            Sign In
                        </Row>
                        <Row className="justify-content-center message__TO left">
                            Sign in with your Toyota password
                        </Row>
                        <Form id="logonFormPassword" noValidate validated={this.props.isFormValid} onSubmit={this.props.handleFormSubmit}>
                            {/* <div id="requiredDiv"><span id="required"><span id="redStar">*</span>Required</span></div> */}
                            <Form.Group id="showUsernameGroup" className="relative">
                                <Form.Label className="absolute inline-label">
                                    {`${this.props.signInType === "EMAIL" ? "Email" : ""}`}
                                    {`${this.props.signInType === "PHONE" ? "Mobile Number" : ""}`}
                                    {`${this.props.signInType === "OTP" ? "Mobile Number" : ""}`}
                                </Form.Label>
                                <Form.Control
                                    required
                                    readOnly
                                    id="showUsername__TO"
                                    data-testid="showUsername"
                                    aria-label="Username"
                                    as="input"
                                    type="text"
                                    name="username"
                                    placeholder={this.props.displayUsername}
                                    bsPrefix="readOnly form-control"
                                />
                            </Form.Group >
                            <Form.Group id="logonPasswordGroup" className="relative">
                                <Form.Label className={`${this.props.floatLabel ? "absolute floating-label" : "absolute inline-label"}
                                        ${this.props.onFocus === true ? "label-black__TO" : ""}
                                        ${this.props.isPasswordValid === false && this.props.onFocus === false ? "label-red__TO" : ""}`}>
                                    Password
                                    <span id="redStar">*</span>
                                </Form.Label>
                                <div className="absolute show-password">
                                    <img onClick={this.props.showHidePassword} src={this.props.showPassword ? require('../../../../static/images/TO/password-hide.svg').default : require('../../../../static/images/TO/password-show.svg').default} alt="showHide"></img>
                                    <span className='show-hide'>{this.props.showPassword ? 'Hide' : 'Show'}</span>
                                </div>
                                <Form.Control
                                    required
                                    id="logonPassword__TO"
                                    data-testid="logonPassword"
                                    aria-label="Password"
                                    as="input"
                                    type={`${this.props.showPassword === false ? "password" : "text"}`}
                                    name="password"
                                    placeholder=""
                                    value={this.props.password}
                                    onChange={this.props.handlePasswordChange}
                                    onFocus={this.props.setFocus}
                                    onBlur={this.props.onBlur}
                                    bsPrefix={`${this.props.isPasswordValid === false ? "highlight-error__TO form-control" : ""}`}
                                />
                                <div
                                    id="passwordAlert"
                                    data-testid="logonPasswordError"
                                    className={`logon-item-error__TO ${this.props.isPasswordValid === false && this.props.onFocus === false ? "block" : "none"}`}
                                    role="alert"
                                    aria-hidden={`${this.props.isPasswordValid === false && this.props.onFocus ? "false" : "true"}`}
                                >
                                    Please enter a password
                                </div>
                                <div style={{ 'marginTop': '8px' }} className="float-left">
                                    <a tabIndex={0} className="link__TO" onClick={this.props.saveURI}>Forgot Password</a>
                                </div>
                            </Form.Group>
                            <div className="required required-left-grid">
                                <span id="redStar">*</span>Required
                            </div>
                            <div className="button-right-cp">
                                <Button data-testid="logonButton" bsPrefix={`${(this.props.isPasswordValid !== true || this.props.isAccountLocked === true) ? "TO__button-disabled" : "TO__button "} `} type={this.props.isPasswordValid && "submit"} >Sign In</Button>
                                {this.props.isAccountLocked && <Button data-testid="passwordResetButton" bsPrefix="TO__button" onClick={() => window.location.replace(appVars.getForgotPasswordURL(this.props.style))} style={{ margin: "10px", padding: "0" }}>Reset Password</Button>}
                            </div>
                            <Image data-testid="loadingGIF" className={`working ${this.props.loading ? "" : "none"}`} id="loadingGIF" src={LoadingGif} aria-hidden="true" />
                        </Form>
                    </div>
                </div>
                <div className="code-bottom" role="complementary">
                    <div className="code-bottom-title">
                        <div className="sign-in">Still having trouble?</div>
                        <br className="mobile-br" />
                        <div className='flex'>
                            <a className="bottom-link" href="/">Try a Different Sign In<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></a>
                            <a className="bottom-link-login bottom-link bottom-link-right" href={appVars.getSupportURL()}>Support<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></a>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default PasswordFormView;